import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { IoDrug, IoDiagnosis, IoDrugGroup, IoDrugTrademark, IoEffect, IoDrugSubstance, } from '../../types';
import _ from 'lodash';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { DrugDataStore } from '../../providers/data/drug-data-store';
import { DrugCategoryPage } from '../drug-category/drug-category';


class ExpandableListModel<TItem> {
  private static collapsedLength: number = 2;
  private fullList: Array<TItem>;
  public isExpanded: boolean;

  setList(fullList: Array<TItem>) {
    this.fullList = fullList;
    this.isExpanded = this.fullList.length <= ExpandableListModel.collapsedLength + 1; // + 1 for expand item
  }

  getItems() {
    return this.fullList.slice(0, this.isExpanded ? undefined : ExpandableListModel.collapsedLength);
  }

  getHiddenCount() {
    return this.fullList.length - this.getItems().length;
  }
}


@IonicPage()
@Component({
  selector: 'page-drug-detail',
  templateUrl: 'drug-detail.html',
})
export class DrugDetailPage {

  selectedDrug: IoDrug;
  selectedDrugSubstance: IoDrugSubstance;
  selectedDiagnosis: IoDiagnosis;
  effectOfSelectedDiagnosis: IoEffect;
  alternativeDrugs: Array<IoDrug> = [];
  groupsGroupedByAlias: Array<{ firstGroup: IoDrugGroup, combinedNames: string }>;
  showFullListOfTrademarks: boolean = false;
  trademarksExpandableList = new ExpandableListModel<IoDrugTrademark>();

  constructor(public navCtrl: NavController, public navParams: NavParams, private analytics: AnalyticsProvider, private dds: DrugDataStore) {
    [this.selectedDrug, this.selectedDiagnosis] = navParams.data;

    this.effectOfSelectedDiagnosis = _.find(this.dds.getEffectsOfDrug(this.selectedDrug), e => this.dds.getDiagnosisOfEffect(e) === this.selectedDiagnosis);
    this.switchToDrug(this.selectedDrug);
    this.calculateAlternativeDrugs();
    this.buildGroupsGroupedByAlias();
  }

  ionViewDidLoad() {

  }

  private getTrademarksIfAny() {
    return this.selectedDrug.isTrademark === false ? this.dds.getTrademarksOfSubstance(this.selectedDrug) : []
  }

  switchToDrug(drug: IoDrug) {
    this.selectedDrug = drug;
    this.trademarksExpandableList.setList(this.getTrademarksIfAny());
    this.dds.calculateEffectStatsWhereMissing([this.selectedDrug]);
    this.selectedDrugSubstance = this.selectedDrug.isTrademark ? this.dds.getSubstanceOfTrademark(this.selectedDrug) : null;
  }

  alternativeDrugClicked(drug: IoDrug) {
    this.analytics.emitEvent('drugDetail', 'alternativeDrugSelected');
    this.navCtrl.push(DrugDetailPage, [drug, this.selectedDiagnosis]);
  }

  groupClicked(group: IoDrugGroup) {
    this.analytics.emitEvent('drugDetail', 'drugGroupClicked');
    this.navCtrl.push(DrugCategoryPage, [group, this.selectedDiagnosis]);
  }

  calculateAlternativeDrugs() {
    if (!this.selectedDiagnosis) {
      return;
    }

    const drugsInGroups = this.dds.getGroupsOfDrug(this.selectedDrug).map(g => this.dds.getDrugsOfGroup(g));
    const drugsThatAreInAllGroups = _.intersection(...drugsInGroups);
    this.alternativeDrugs = drugsThatAreInAllGroups.filter(d => !_.includes(this.dds.getEffectsOfDrug(d).map(e => this.dds.getDiagnosisOfEffect(e)), this.selectedDiagnosis))
  }

  buildGroupsGroupedByAlias() {
    let groupIdSubstitution = 10000; // avoid id collision
    const groups = this.dds.getGroupsOfDrug(this.selectedDrug);
    const mapAliasGroups = (groups: IoDrugGroup[]) => { return { firstGroup: groups[0], combinedNames: groups.map(g => g.name).join(" / ") } }
    this.groupsGroupedByAlias = _.map(_.groupBy(groups, (g: IoDrugGroup) => g.aliasId || groupIdSubstitution++), mapAliasGroups);
    this.groupsGroupedByAlias.sort((a, b) => {
      return (a.combinedNames).localeCompare((b.combinedNames), 'de-DE');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/drug-detail/drug-detail.ts